import React, { useEffect, useState } from 'react';
import { List_dispute } from '../../../Utils/Api';
import { Link } from 'react-router-dom';
import Loader from '../../../Common/Loader'; // Corrected path from '../../Common/Loader'


const DisputeList = () => {
    const [disputes, setDisputes] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchDisputes = async () => {
        setLoading(true);
        try {
            const response = await List_dispute();
            if (response?.data?.success) {
                setDisputes(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching disputes:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDisputes();
    }, []);

    return (
        <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="mb-0">Dispute Management</h4>
            </div>

            <div className="card">
                <div className="card-body">
                    {loading ? (
                        <div className="text-center p-4">Loading...</div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Raised By</th>
                                        <th>Reason</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {disputes.length === 0 ? (
                                        <tr>
                                            <td colSpan="5" className="text-center">No disputes found.</td>
                                        </tr>
                                    ) : (
                                        disputes.map((dispute) => (
                                            <tr key={dispute._id}>
                                                <td>{new Date(dispute.createdAt).toLocaleDateString()}</td>
                                                <td>{dispute.raisedBy?.name || 'Unknown'} <small className='text-muted'>({dispute.raisedBy?.role === 1 ? 'Skillster' : 'Gigster'})</small></td>
                                                <td>{dispute.reason}</td>
                                                <td>
                                                    <span className={`badge bg-${dispute.status === 'Resolved' ? 'success' :
                                                        dispute.status === 'Filed' ? 'danger' :
                                                            dispute.status === 'Responding' ? 'warning' : 'primary'
                                                        }`}>
                                                        {dispute.status}
                                                    </span>
                                                </td>
                                                <td>
                                                    <Link to={`/disputes/${dispute._id}`} className="btn btn-sm btn-outline-primary">
                                                        View Details
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DisputeList;
